import { Injectable } from '@angular/core';

@Injectable()
export class TabService {
  tab;

  constructor() { }

  openTab(url, spec) {
    this.tab = window.open(url, spec);
  }

  closeTab() {
    if(this.tab) {
      this.tab.close();
      this.tab = null;
    }
  }

}